import { Box, Tooltip, SxProps, Theme, styled, alpha } from '@mui/material';
import React from 'react';

type ToolTipStatusColor = 'PENDING' | 'MAIN' | 'SUCCESS' | 'REJECTED';
export interface TooltipStatusProps {
  label: string;
  tooltip: string;
  color: ToolTipStatusColor;
  icon?: React.ReactNode;
  sx?: SxProps<Theme>;
}

const StatusBadge = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'status',
})<{ status?: ToolTipStatusColor }>(({ theme, status }) => {
  const colorMap: Record<ToolTipStatusColor, { bg: string; color: string; hover: string }> = {
    PENDING: {
      bg: alpha(theme.palette.grey[600], 0.1),
      color: theme.palette.grey[700],
      hover: alpha(theme.palette.grey[600], 0.15),
    },
    MAIN: {
      bg: alpha(theme.palette.primary.main, 0.1),
      color: theme.palette.primary.main,
      hover: alpha(theme.palette.primary.main, 0.15),
    },
    SUCCESS: {
      bg: alpha(theme.palette.success.main, 0.1),
      color: theme.palette.success.main,
      hover: alpha(theme.palette.success.main, 0.15),
    },
    REJECTED: {
      bg: alpha(theme.palette.error.main, 0.1),
      color: theme.palette.error.main,
      hover: alpha(theme.palette.error.main, 0.15),
    },
  };
  const { bg, color, hover } = colorMap[status || 'PENDING'];
  return {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    padding: '4px 10px',
    borderRadius: 6,
    fontSize: '0.8rem',
    fontWeight: 500,
    whiteSpace: 'nowrap',
    backgroundColor: bg,
    color,
    cursor: 'help',
    transition: 'all 0.2s',
    width: 'fit-content',
    '&:hover': {
      backgroundColor: hover,
    },
  };
});

export const TooltipStatus: React.FC<TooltipStatusProps> = ({ label, tooltip, icon, color }) => (
  <Tooltip title={tooltip} placement="top" arrow enterDelay={300} leaveDelay={200}>
    <StatusBadge status={color}>
      {icon}
      {label}
    </StatusBadge>
  </Tooltip>
);

export default TooltipStatus;
